import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import validateTaxReturnField from '../helpers/validateTaxReturnField'
import TaxFormInput from '../../common/TaxFormInput'
import TaxForm1040 from '../images/taxReturnForms/1040.png'
import states from '../../common/helpers/USStates'
import StateSelect from '../../common/StateSelect'

const ShowHide = styled.div`
  ${props => props.hide ? 'opacity: 0' : 'opacity: 1'}
`

const FormContainer = styled.form`
  position: relative;
`
const Input = styled(TaxFormInput)`
  position: absolute;
`
const Year = styled.h1`
  position: absolute;
  top: 3px;
  left: 397px;
  font-weight: bold;
  color: #56565a;
`
const Select = styled(StateSelect)`
  position: absolute;
  left: 272px;
  top: 185px;
  font-size: 12px !important;
  height: 21px;
  padding: 0px 10px;
  background: #add6eb;
  border-radius: 3px;
  border: 1px solid #cecfcf;
  width: auto;
  margin: 0;
  &:focused {
    border: 1px solid #39c;
  }
`
export default class Form1040 extends React.Component {
  static propTypes = {
    defaults: PropTypes.object,
    onDataChange: PropTypes.func.isRequired,
    year:         PropTypes.number.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      firstName: '',
      lastName: '',
      tin: '',
      street: '',
      apt: '',
      city: '',
      state: 'default',
      zip: '',
      hide: true,
      ...props.defaults
    }
  }
  showComponenet = () => {
    setTimeout(()=> this.setState({hide: false}), 250)
  }
  componentDidMount() {
    // Check if defaults are valid
    this.showComponenet()
    const { onDataChange } = this.props
    onDataChange({
      ...this.state,
      isValid: this.validate(this.state)
    })
  }
  validate = formData => {
    for (const [key, value] of Object.entries(formData)) {
      if (!validateTaxReturnField(key, value) && key !== 'apt' && key !== 'hide') {
        return false
      }
    }
    return true
  }
  renderFormImage = () => {
    return <img src={TaxForm1040} />
  }
  renderPersonalInfo = () => {
    const { state, firstName, lastName, tin, street, zip, apt, city } = this.props.defaults
    return (
      <div>
        <Input
          absolute
          left={6}
          top={63}
          width={254}
          onChange={e => this.onChange('firstName', e.target.value)}
          label="First Name and Initial"
          inputRef={node => this.firstName = node}
          required
          defaultValue={firstName}
          id="tax_form_first_name"
        />
        <Input
          absolute
          top={63}
          left={272}
          width={355}
          label="Last Name"
          onChange={e => this.onChange('lastName', e.target.value)}
          inputRef={node => this.lastName = node}
          required
          defaultValue={lastName}
          id="tax_form_last_name"
        />
        <Input
          label="Social Security Number"
          type="ssn"
          absolute
          top={63}
          left={639}
          onChange={e => this.onChange('tin', e.target.value)}
          required
          defaultValue={tin}
          id="tax_form_ssn"
        />
        <Input
          label="Home address (number and street). If you have a P.O box, see the intructions."
          absolute
          top={133}
          left={6}
          width={547}
          onChange={e => this.onChange('street', e.target.value)}
          required
          defaultValue={street}
          id="tax_form_street"
        />
        <Input
          label="Apt. No."
          absolute
          left={565}
          top={133}
          width={62}
          type="number"
          onChange={e => this.onChange('apt', e.target.value)}
          defaultValue={apt}
          id="tax_form_apt"
        />
        <Input
          label="City"
          absolute
          top={168}
          left={6}
          width={230}
          onChange={e => this.onChange('city', e.target.value)}
          required
          defaultValue={city}
          id="tax_form_city"
        />
        <Select
          onChange={e => this.onChange('state', e.target.value)}
          id="tax_form_state"
          defaultValue={state}
        />
        <Input
          label="Zip"
          absolute
          top={168}
          left={468}
          width={77}
          type="zip"
          onChange={e => this.onChange('zip', e.target.value)}
          required
          defaultValue={zip}
          id="tax_form_zip"
        />
      </div>
    )
  }
  renderYear = () => {
    return (
      <Year>{this.props.year}</Year>
    )
  }
  onChange = (key, value) => {
    const { onDataChange } = this.props
    this.setState(
      { [key]: value },
      () => {
        onDataChange({
          ...this.state,
          name: `${this.state.firstName} ${this.state.lastName}`,
          isValid: this.validate(this.state)
        })
      }
    )
  }
  render() {
    return (
      <ShowHide hide={this.state.hide}>
        <FormContainer >
          {this.renderFormImage()}
          {this.renderPersonalInfo()}
          {this.renderYear()}
        </FormContainer>
      </ShowHide>
    )
  }
}